import { Stack, Avatar, Typography, Button } from "@mui/material";
import { NewDialogActions, NewDialogContent } from "components";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

export default function FinalStep({ handleClose }) {
  return (
    <>
      <NewDialogContent isPopup>
        <Stack p={1} flex={2} rowGap={1} bgcolor="background.paper">
          <Stack
            rowGap={3}
            flexGrow={1}
            justifyContent="center"
            alignItems="center"
          >
            <Avatar
              sx={{
                width: 120,
                height: 120,
                fontSize: 60,
                bgcolor: "error.lighter",
              }}
            >
              <ErrorOutlineRoundedIcon fontSize="inherit" color="error" />
            </Avatar>
            <Typography variant="subtitle1" color="error.main">
              خطای ناشناخته
            </Typography>
          </Stack>
        </Stack>
      </NewDialogContent>
      <NewDialogActions>
        <Stack
          width="100%"
          alignItems="center"
          direction="row-reverse"
          justifyContent="space-between"
        >
          <Button
            autoFocus
            size="medium"
            color="primary"
            variant="contained"
            onClick={handleClose}
            sx={{ minWidth: 120 }}
          >
            تلاش مجدد
          </Button>
        </Stack>
      </NewDialogActions>
    </>
  );
}
